import { type Lang, type TranslationKey, translate } from '../../i18n';
import { el } from '../../lib/dom';
import { createModal } from './modal';

/**
 * Splošna potrditev nepovratnega dejanja (`.cm-scrim` iz DS).
 *
 * Brisanje zgodovine je nepovratno in zato **nikoli en klik** (P2 §4.7, isti
 * princip kot brisanje postaje). Naslov, telo in napis dejanja se podajo ob
 * odpiranju, ker isti modal potrjuje več stvari (počisti vse · počisti eno
 * postajo). Fokus gre na »prekliči« — privzeti cilj tipke Enter pri
 * nepovratnem dejanju ne sme biti dejanje samo.
 */

export interface ConfirmRequest {
  titleKey: TranslationKey;
  bodyKey: TranslationKey;
  /** Vidno besedilo potrditvenega gumba. */
  actionKey: TranslationKey;
  onConfirm(): void;
}

export interface ConfirmDialog {
  open(request: ConfirmRequest): void;
  setLang(lang: Lang): void;
}

export function createConfirmDialog(root: HTMLElement): ConfirmDialog {
  let lang: Lang = 'en';
  let pending: ConfirmRequest | null = null;

  const modal = createModal('nw-confirm-title');
  const body = el('p', { class: 'desc' });
  modal.body.append(body);
  // Dejanje je rušilno: rdeč gumb, ne primaren.
  modal.confirm.classList.remove('primary');
  modal.confirm.classList.add('danger');

  root.append(modal.scrim);

  modal.confirm.addEventListener('click', () => {
    const request = pending;
    pending = null;
    modal.hide();
    request?.onConfirm();
  });

  function applyLang(): void {
    modal.close.setAttribute('aria-label', translate(lang, 'dialog.close'));
    modal.cancel.textContent = translate(lang, 'dialog.cancel');
    if (pending === null) return;
    modal.title.textContent = translate(lang, pending.titleKey);
    body.textContent = translate(lang, pending.bodyKey);
    modal.confirm.textContent = translate(lang, pending.actionKey);
  }

  return {
    setLang(next) {
      lang = next;
      applyLang();
    },

    open(request) {
      pending = request;
      applyLang();
      modal.show(modal.cancel);
    },
  };
}
